export default "__VITE_ASSET__ttNoju5l__"